import React, { useState } from 'react';

const DOW = ['LUN', 'MAR', 'MER', 'JEU', 'VEN', 'SAM', 'DIM'];
const MONTH_NAMES = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

function CalendarView({ tasks, onOpenTask }) {
  const initial = tasks.find((t) => t.due_date) ? new Date(tasks.find((t) => t.due_date).due_date) : new Date();
  const [viewDate, setViewDate] = useState(new Date(initial.getFullYear(), initial.getMonth(), 1));

  const year = viewDate.getFullYear();
  const month = viewDate.getMonth();

  const firstDay = new Date(year, month, 1);
  const startOffset = (firstDay.getDay() + 6) % 7; // Monday = 0
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const cells = [];
  for (let i = 0; i < startOffset; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  const tasksByDay = {};
  tasks.forEach((t) => {
    if (!t.due_date) return;
    const d = new Date(t.due_date);
    if (d.getFullYear() === year && d.getMonth() === month) {
      const day = d.getDate();
      if (!tasksByDay[day]) tasksByDay[day] = [];
      tasksByDay[day].push(t);
    }
  });

  const changeMonth = (delta) => setViewDate(new Date(year, month + delta, 1));

  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2 style={{ margin: 0 }}>{MONTH_NAMES[month]} {year}</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="icon-btn" onClick={() => changeMonth(-1)}>←</button>
          <button className="icon-btn" onClick={() => changeMonth(1)}>→</button>
        </div>
      </div>

      <div className="calendar-grid">
        {DOW.map((d) => (
          <div key={d} className="calendar-dow">{d}</div>
        ))}
        {cells.map((day, i) => (
          <div key={i} className={`calendar-cell ${day == null ? 'empty' : ''}`}>
            {day != null && (
              <>
                <div className="calendar-date">{day}</div>
                {(tasksByDay[day] || []).map((t) => (
                  <div key={t.id} className="calendar-task-chip" title={t.name} onClick={() => onOpenTask(t)} style={{ cursor: 'pointer' }}>
                    {t.name}
                  </div>
                ))}
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default CalendarView;
